import React, { useState } from "react";
import AdminDashboardNavbar from "../../../../../components/ui/Admin/AdminDashboardNavbar";
import AdminTopBar from "../../../../../components/ui/Admin/AdminTopBar";
import Chart from "react-apexcharts";
import { AiFillDelete } from "react-icons/ai";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteDriverById,
  fetchDrivers,
  fetchSuspendedDrivers,
  rejectDriverApplication,
  suspendDriverById,
  unsuspendDriverById,
} from "../../../../../redux/slices/adminSlice";
import { ImSpinner2 } from "react-icons/im";
import { Helmet } from "react-helmet";
import { ToastContainer } from "react-toastify";
import { FaXmark } from "react-icons/fa6";
import Modal from "react-modal";
import SimpleProfileCard from "../../../../../components/ui/SimpleProfileCard";
import { MdAirplanemodeActive } from "react-icons/md";
import moment from "moment";
import GoogleMapsWithDirections from "../../../../../components/ui/GoogleMapsWithDirection";


function AdminDashboardDriversPage() {
  // Mobile navbar handler
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  const dispatch = useDispatch();
  const { isLoading, drivers, suspendedDrivers, driverData, token, admin } =
    useSelector((store) => store.admin);

  // Chart Setup
  const [driverDataByMonth, setDriverDataByMonth] = useState();
  const state = {
    options: {
      chart: {
        id: "apexchart-example",
        fontFamily: "Poppins",
        style: {
          fontSize: ".8rem",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        colors: ["#E2B442", "#262471"],
      },
      fill: {
        colors: ["#E2B442", "#262471"],
        pattern: {
          style: "circles",
          strokeWidth: 1,
          height: 1,
          width: 1,
        },
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      yaxis: {
        labels: {
          show: true,
          minWidth: 0,
          maxWidth: 160,
          style: {
            colors: [],
            fontSize: "30px",
            fontFamily: "Poppins",
            cssClass: "text-xs",
          },
          formatter: (value) => {
            const formattedValue = Intl.NumberFormat("en-US", {}).format(value);
            return formattedValue;
          },
        },
      },
    },
    series: [
      {
        name: "",
        data: driverDataByMonth,
      },
    ],
  };

  // Fetch Drivers
  useEffect(() => {
    dispatch(fetchSuspendedDrivers(token));
    dispatch(fetchDrivers(token));
  }, [token]);

  // Configure driverDataByMonth
  useEffect(() => {
    function prepareDriverDataByMonth() {
      let preparedData = [];
      for (let i = 1; i <= 12; i++) {
        driverData?.forEach((data) => {
          if (data?._id?.month == i) {
            preparedData.push(data?.count);
          } else {
            preparedData.push(0);
          }
        });
      }
      setDriverDataByMonth(preparedData);
      console.log("PREAPRED DATA:", preparedData);
    }

    prepareDriverDataByMonth();
  }, [token, driverData]);

  // function to handle deleting a driver
  function deleteDriver(driverId) {
    dispatch(deleteDriverById({ token, driverId }));
  }

  // function to handle suspending a driver
  function handleSuspendDriver(driverId) {
    dispatch(suspendDriverById({ token, driverId }));
  }

  // function to handle unsuspending a driver
  function handleUnsuspendDriver(driverId) {
    dispatch(unsuspendDriverById({ token, driverId }));
  }

  // function to handle suspending a driver
  function handleRejectDriverApplication(driverId) {
    dispatch(rejectDriverApplication({ token, driverId }));
  }

  // Driver details modal
  const [isDriverDetailModalOpen, setIsDriverDetailModalOpen] = useState(false);
  const [currentDriver, setCurrentDriver] = useState();

  // Tabs
  const [isOverview, setIsOverview] = useState(true);
  const [isJobs, setIsJobs] = useState(false);

  return (
    <div className="">
      <ToastContainer />
      <Helmet>
        <title>Manage Drivers | Shuttlelane Portal Admin Dashboard</title>
      </Helmet>

      {/* Navbar here */}
      <AdminDashboardNavbar
        link="users"
        sublink="manage-drivers"
        isNavbarOpen={isNavbarOpen}
        setIsNavbarOpen={setIsNavbarOpen}
      />

      {/* Driver Detail Modal */}
      <Modal
        isOpen={isDriverDetailModalOpen}
        onRequestClose={() => setIsDriverDetailModalOpen(false)}
        className="flex h-full min-h-screen justify-center items-center lg:px-24 px-7 overflow-y-scroll"
      >
        <div className="bg-white shadow-lg rounded-lg text-shuttlelaneBlack w-full p-7 px-10 h-[90vh] overflow-y-scroll shuttlelaneScrollbar">
          <div className="flex items-center justify-between">
            <div className="border-b-[1px] border-b-slate-100 w-full pb-4">
              <h4 className="font-semibold">Driver Details</h4>
              <small>
                {currentDriver?.firstName} {currentDriver?.lastName}
              </small>
            </div>

            <FaXmark
              size={20}
              onClick={() => setIsDriverDetailModalOpen(false)}
              className="cursor-pointer"
            />
          </div>

          {/* Profile card */}
          <div className="w-full mt-10">
            <div className="flex flex-col gap-y-5 gap-x-4">
              <SimpleProfileCard user={currentDriver} />
            </div>
          </div>

          {/* Tabs */}
          {/* Overview */}
          {/* Jobs */}
          <div className="mt-10">
            {/* Options */}
            <div className="mt-9 flex justify-between items-baseline pb-1 transition-all border-b-[.3px] border-b-gray-200">
              <div className="flex items-center gap-x-10 gap-y-4 flex-wrap">
                <span
                  onClick={() => {
                    setIsOverview(true);
                    setIsJobs(false);
                  }}
                  className={`text-xs cursor-pointer transition-all ${
                    isOverview
                      ? "font-semibold text-shuttlelaneBlack border-b-2 border-b-shuttlelaneBlack"
                      : "text-gray-400"
                  }`}
                >
                  Overview
                </span>
                <span
                  onClick={() => {
                    setIsOverview(false);
                    setIsJobs(true);
                  }}
                  className={`text-xs cursor-pointer transition-all ${
                    isJobs
                      ? "font-semibold text-shuttlelaneBlack border-b-2 border-b-shuttlelaneBlack"
                      : "text-gray-400"
                  }`}
                >
                  All Jobs
                </span>
              </div>
            </div>

            {/* Overview */}
            {isOverview && (
              <div className="h-full mt-10 flex flex-col gap-y-5 pb-20">
                <div className="flex flex-col">
                  <p className="font-semibold text-shuttlelaneBlack">
                    Contact Information
                  </p>
                  <small className="text-sm text-gray-400">
                    Full Name: {currentDriver?.firstName}{" "}
                    {currentDriver?.middleName} {currentDriver?.lastName}
                  </small>
                  <small className="text-sm text-gray-400">
                    Email Address: {currentDriver?.email}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Gender: {currentDriver?.gender}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Education: {currentDriver?.education}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Phone: {currentDriver?.mobile}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Alternative Phone: {currentDriver?.alternateMobile}
                  </small>
                </div>

                <div className="flex flex-col">
                  <p className="font-semibold text-shuttlelaneBlack">
                    Personal Information
                  </p>
                  <small className="text-sm text-gray-400">
                    Date of birth: {currentDriver?.dateOfBirth}
                  </small>
                  <small className="text-sm text-gray-400">
                    Address: {currentDriver?.address}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    City: {currentDriver?.city}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Marital Status: {currentDriver?.maritalStatus}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    BVN: {currentDriver?.bvn}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    NIN: {currentDriver?.nin}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Bank Name: {currentDriver?.bank}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Account Number: {currentDriver?.accountNumber}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Account Name: {currentDriver?.accountName}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Driver's License Number: {currentDriver?.driversLicense}
                  </small>
                </div>

                <div className="flex flex-col">
                  <p className="font-semibold text-shuttlelaneBlack">
                    Car Details
                  </p>
                  <small className="text-sm text-gray-400">
                    Car Type: {currentDriver?.carType}
                  </small>
                  <small className="text-sm text-gray-400">
                    Car Name: {currentDriver?.carName}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Car Model: {currentDriver?.carModel}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Car Year: {currentDriver?.carYear}
                  </small>
                </div>

                <div className="flex flex-col">
                  <p className="font-semibold text-shuttlelaneBlack">
                    Emergency Contact
                  </p>
                  <small className="text-sm text-gray-400">
                    Full Name: {currentDriver?.emergencyFirstName}{" "}
                    {currentDriver?.emergencyLastName}
                  </small>
                  <small className="text-sm text-gray-400">
                    Address: {currentDriver?.emergencyAddress}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Phone Number: {currentDriver?.emergencyMobile}
                  </small>
                  <small className="text-sm text-gray-400 mt-1">
                    Relationship: {currentDriver?.emergencyRelationship}
                  </small>
                </div>

                <div className="flex flex-col">
                  <p className="font-semibold text-shuttlelaneBlack">
                    Additional Information
                  </p>
                  <small className="text-sm text-gray-400">
                    Drives for other ride hailing platforms?:{" "}
                    {currentDriver?.isDrivingForHailingPlatforms ? "Yes" : "No"}{" "}
                  </small>
                  {currentDriver?.isDrivingForHailingPlatforms && (
                    <small className="text-sm text-gray-400">
                      Platforms: {currentDriver?.hailingPlatforms}
                    </small>
                  )}
                </div>
              </div>
            )}

            {isJobs && (
              <div className="mt-10">
                {/* Most recent booking */}
                {currentDriver?.completedBookings?.length > 0 && (
                  <div className="">
                    <div className="flex items-center gap-x-2">
                      <p className="font-medium">Most Recent Job</p>
                      <div className="h-2 w-2 rounded-full bg-shuttlelaneGold"></div>
                    </div>

                    <div className="h-auto w-full rounded-lg allRoundBoxShadow overflow-hidden mt-4">
                      {currentDriver?.completedBookings?.length > 0 && (
                        <>
                          <div className="flex items-center justify-center h-[220px] min-h-[220px] max-h-[220px] w-full rounded-tr-lg rounded-tl-lg">
                            <GoogleMapsWithDirections
                              pickupAddress={
                                currentDriver?.completedBookings[0]?.booking
                                  ?.pickupAddress
                              }
                              pickupCoordinates={
                                currentDriver?.completedBookings[0]?.booking
                                  ?.pickupCoordinates
                              }
                              dropoffAddress={
                                currentDriver?.completedBookings[0]?.booking
                                  ?.dropoffAddress
                              }
                              dropoffCoordinates={
                                currentDriver?.completedBookings[0]?.booking
                                  ?.dropoffCoordinates
                              }
                            />
                          </div>

                          <div className="flex items-center justify-between p-4">
                            <div className="flex items-center gap-x-2">
                              <div className="h-14 w-14 rounded-lg bg-white shadow-lg flex items-center justify-center">
                                <MdAirplanemodeActive size={20} className="" />
                              </div>

                              <div className="flex flex-col gap-y-1">
                                <small className="font-semibold">
                                  {
                                    currentDriver?.completedBookings[0]?.booking
                                      ?.pickupAddress
                                  }
                                </small>
                                <small className="">
                                  {moment(
                                    currentDriver?.completedBookings[0]?.booking
                                      ?.pickupDate
                                  ).format("DD MM, YYYY")}{" "}
                                  .{" "}
                                  {moment(
                                    currentDriver?.completedBookings[0]?.booking
                                      ?.pickupTime
                                  ).format("H:MM A")}
                                </small>
                                <small className="text-green-500">
                                  {
                                    currentDriver?.completedBookings[0]
                                      ?.bookingStatus
                                  }
                                </small>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}

                {/* Bookings */}
                {/* Recent Bookings */}
                <div className="mt-11 w-full">
                  <div className="w-full rounded-lg border-[1.3px] lg:border-[.3px] p-3 border-gray-100 h-auto">
                    <div className="flex items-baseline justify-between">
                      <div className="flex items-center gap-x-2">
                        <p className="font-medium">
                          Completed Bookings -{" "}
                          {currentDriver?.completedBookings?.length}
                        </p>
                        <div className="h-2 w-2 rounded-full bg-shuttlelaneGold"></div>
                      </div>
                    </div>

                    <div className="overflow-x-scroll shuttlelaneScrollbarHoriz shuttlelaneScrollbar">
                      {/* Table header */}
                      <div className="flex justify-between items-baseline mb-2 border-b-[.3px] border-b-gray-100 text-gray-400 mt-2">
                        <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                          Booking Ref
                        </p>
                        <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                          Passenger
                        </p>
                        <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                          Pickup Location
                        </p>
                        <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                          Pickup Date & Time
                        </p>
                        <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                          Booking Type
                        </p>
                      </div>

                      {currentDriver?.completedBookings?.map((booking) => (
                        <div className="cursor-pointer flex justify-between items-baseline mb-2 pb-2 border-b-[.3px] border-b-gray-100 text-shuttlelaneBlack mt-4">
                          <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                            {booking?.bookingReference}
                          </p>
                          <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                            {booking?.user?.firstName ?? booking?.firstName}{" "}
                            {booking?.user?.lastName ?? booking?.lastName}
                          </p>
                          <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                            {booking?.booking?.pickupAddress}
                          </p>
                          <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                            {moment(booking?.pickupDate).format("MMM DD, YYYY")}
                            , {moment(booking?.pickupTime).format("H:MM A")}
                          </p>
                          <p className="min-w-[200px] w-[200px] lg:w-[20%] text-xs">
                            {booking?.bookingType}
                          </p>
                        </div>
                      ))}

                      {currentDriver?.completedBookings?.length < 1 && (
                        <div className="flex justify-center items-center h-full w-full mb-2 pb-2 text-shuttlelaneBlack mt-4">
                          <p className="w-full text-xs text-center">
                            {currentDriver?.firstName} {currentDriver?.lastName}{" "}
                            has not completed any bookings just yet...
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Modal>

      {/* Main content goes here */}
      <div className="w-full min-h-screen lg:pl-[6%] bg-[#fff] text-shuttlelaneBlack">
        <div className="px-7 py-5 relative">
          {/* Top bar */}
          <AdminTopBar
            isNavbarOpen={isNavbarOpen}
            setIsNavbarOpen={setIsNavbarOpen}
          />

          {/* Main content */}
          <div className="mt-24 pt-2">
            <div className="flex gap-x-5">
              {/* Booking Summary - Total number of bookings */}
              <div className="w-full">
                {/* Bar Chart */}
                <div className="w-full">
                  <div className="w-full rounded-lg border-[1.3px] lg:border-[.3px] p-3 border-gray-100 h-auto">
                    <div className="flex items-baseline justify-between">
                      <div className="flex items-center gap-x-2">
                        <p className="font-medium">
                          Total Approved Drivers - {drivers?.length}
                        </p>
                        <div className="h-2 w-2 rounded-full bg-shuttlelaneGold"></div>
                      </div>
                      {/* <p className="text-sm underline offset-7">2023</p> */}
                    </div>

                    {/* Area chart */}
                    <div className="mt-2 text-xs">
                      <Chart
                        options={state.options}
                        series={state.series}
                        type="area"
                        width={"100%"}
                        height={250}
                      />
                    </div>
                  </div>
                </div>

                {/* Drivers */}
                <div className="w-full">
                  {/* Searchbar */}
                  {/* <div className="flex items-center gap-x-3 border-[1.3px] lg:border-[.3px] border-gray-300 rounded-lg px-2 my-2 lg:w-1/4 w-full">
                    <BiSearch size={16} className="text-gray-400 rotate-90" />
                    <input
                      type="search"
                      placeholder="Search"
                      className="w-full h-8 bg-transparent text-xs focus:outline-none placeholder:text-xs placeholder:text-gray-400"
                    />
                  </div> */}

                  {suspendedDrivers?.length > 0 && (
                    <div className="mt-7 w-full rounded-lg border-[1.3px] lg:border-[.3px] p-3 border-gray-100 h-auto">
                      <div className="flex items-baseline justify-between">
                        <div className="flex items-center gap-x-2">
                          <p className="font-medium">Suspended Drivers</p>
                          <div className="h-2 w-2 rounded-full bg-shuttlelaneGold"></div>
                        </div>
                      </div>

                      {/* Table header */}
                      <div className="flex justify-between items-baseline mb-2 border-b-[.3px] border-b-gray-100 text-gray-400 mt-2">
                        <p className="w-200px lg:w-[25%] text-xs">Full name</p>
                        <p className="w-200px lg:w-[25%] text-xs">
                          Email Address
                        </p>
                        <p className="w-200px lg:w-[25%] text-xs">
                          Phone Number
                        </p>
                        {/* <p className="w-200px lg:w-[25%] text-xs">Last Booking</p> */}
                        {admin?.role !== "Blogger" && (
                          <p className="w-200px lg:w-[25%] text-xs">Actions</p>
                        )}
                      </div>
                      {/* Table body - Driver card */}
                      {suspendedDrivers?.map((driver) => (
                        <div className="flex justify-between items-baseline mb-2 pb-2 border-b-[.3px] border-b-gray-100 text-shuttlelaneBlack mt-4">
                          <p
                            onClick={() => setCurrentDriver(driver)}
                            className={`w-200px lg:w-[25%] text-xs ${
                              isLoading && "text-gray-400"
                            }`}
                          >
                            {driver?.firstName} {driver?.lastName}
                          </p>
                          <p
                            onClick={() => setCurrentDriver(driver)}
                            className={`w-200px lg:w-[25%] text-xs ${
                              isLoading && "text-gray-400"
                            }`}
                          >
                            {driver?.email}
                          </p>
                          <p
                            onClick={() => setCurrentDriver(driver)}
                            className={`w-200px lg:w-[25%] text-xs ${
                              isLoading && "text-gray-400"
                            }`}
                          >
                            {driver?.countryCode} {driver?.mobile}
                          </p>
                          {/* <p className="w-200px lg:w-[25%] text-xs">
                        12 November 2023
                      </p> */}

                          {admin?.role !== "Blogger" && (
                            <div className="w-[180px] lg:w-[25%] flex items-center gap-x-3">
                              {!isLoading ? (
                                <div className="flex flex-row items-center gap-x-2">
                                  <button
                                    onClick={() =>
                                      handleUnsuspendDriver(driver?._id)
                                    }
                                    className="h-7 w-28 p-2 text-white bg-shuttlelanePurple rounded-lg text-xs"
                                  >
                                    Unsuspend
                                  </button>
                                  <button
                                    onClick={() => deleteDriver(driver?._id)}
                                    className="text-xs"
                                  >
                                    <AiFillDelete
                                      size={16}
                                      className="text-red-500"
                                    />
                                  </button>
                                </div>
                              ) : (
                                <ImSpinner2
                                  size={16}
                                  className="text-gray-400 animate-spin"
                                />
                              )}
                            </div>
                          )}
                        </div>
                      ))}

                      {suspendedDrivers?.length < 1 && (
                        <div className="flex justify-center">
                          <p className="text-center text-sm">
                            No data to show for now...
                          </p>
                        </div>
                      )}
                    </div>
                  )}

                  <div className="mt-7 w-full rounded-lg border-[1.3px] lg:border-[.3px] p-3 border-gray-100 h-auto">
                    <div className="flex items-baseline justify-between">
                      <div className="flex items-center gap-x-2">
                        <p className="font-medium">Approved Drivers</p>
                        <div className="h-2 w-2 rounded-full bg-shuttlelaneGold"></div>
                      </div>
                    </div>

                    <div className="overflow-x-scroll shuttlelaneScrollbarHoriz shuttlelaneScrollbar">
                      {/* Table header */}
                      <div className="maxContent w-max lg:w-full flex justify-between items-baseline mb-2 border-b-[.3px] border-b-gray-100 text-gray-400 mt-2">
                        <p className="w-[200px] lg:w-[25%] text-xs">
                          Full name
                        </p>
                        <p className="w-[200px] lg:w-[25%] text-xs">
                          Email Address
                        </p>
                        <p className="w-[200px] lg:w-[25%] text-xs">
                          Phone Number
                        </p>
                        {/* <p className="w-[200px] lg:w-[25%] text-xs">Last Booking</p> */}
                        {admin?.role !== "Blogger" && (
                          <p className="w-[200px] lg:w-[25%] text-xs">
                            Actions
                          </p>
                        )}
                      </div>
                      {/* Table body - Driver card */}
                      {drivers?.map((driver) => (
                        <button
                          onClick={() => {
                            setIsDriverDetailModalOpen(true);
                            setCurrentDriver(driver);
                            console.log("CURRENT DRIVER:", driver);
                          }}
                          className="maxContent w-max lg:w-full flex justify-between items-baseline mb-2 pb-2 border-b-[.3px] border-b-gray-100 text-shuttlelaneBlack mt-4"
                        >
                          <p
                            className={`text-left w-[200px] lg:w-[25%] text-xs ${
                              isLoading && "text-gray-400"
                            }`}
                          >
                            {driver?.firstName} {driver?.lastName}
                          </p>
                          <p
                            className={`text-left w-[200px] lg:w-[25%] text-xs ${
                              isLoading && "text-gray-400"
                            }`}
                          >
                            {driver?.email}
                          </p>
                          <p
                            className={`text-left w-[200px] lg:w-[25%] text-xs ${
                              isLoading && "text-gray-400"
                            }`}
                          >
                            {driver?.countryCode} {driver?.mobile}
                          </p>
                          {/* <p className="text-left w-[200px] lg:w-[25%] text-xs">
                        12 November 2023
                      </p> */}

                          {admin?.role !== "Blogger" && (
                            <div className="w-[200px] lg:w-[25%] flex items-center gap-x-3">
                              {!isLoading ? (
                                <div className="flex flex-row items-center gap-x-2">
                                  <button
                                    onClick={() =>
                                      handleSuspendDriver(driver?._id)
                                    }
                                    className="h-7 w-28 p-2 text-white bg-shuttlelanePurple rounded-lg text-xs"
                                  >
                                    Suspend
                                  </button>
                                  <button
                                    onClick={() => deleteDriver(driver?._id)}
                                    className="text-xs"
                                  >
                                    <AiFillDelete
                                      size={16}
                                      className="text-red-500"
                                    />
                                  </button>
                                </div>
                              ) : (
                                <ImSpinner2
                                  size={16}
                                  className="text-gray-400 animate-spin"
                                />
                              )}
                            </div>
                          )}
                        </button>
                      ))}

                      {drivers?.length < 1 && (
                        <div className="flex justify-center">
                          <p className="text-center text-sm">
                            No data to show for now...
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboardDriversPage;
